import React from 'react';
import { profiles } from './data';
import './Team.scss';

const Team=()=>{
    return(
        <div className="team">
            <ul>
                {profiles.map((item) =>{
                    return(
                        <li className={`list-item ${item.styles}`}>
                          <div className="image" style={{ backgroundImage: `url(${item.image})` }}>

                          </div>
                          <h2>{item.title}</h2>
                        </li>
                    )
                })}
            </ul>
        </div>
    )
};
export default Team ;